import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';

export function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="404 - Page Not Found | Safaza Technologies, Inc."
        description="The requested page could not be located on Safaza Technologies, Inc."
      />

      <section className="flex-1 flex items-center justify-center py-24 sm:py-36 bg-[#F6F8FB]">
        <div className="max-w-md mx-auto px-4 text-center">
          <div className="double-bezel">
            <div className="double-bezel-inner p-8 sm:p-12">
              <span className="text-xs font-mono font-bold uppercase tracking-widest text-[#0D66E4] block mb-3">
                ERROR 404
              </span>
              <h1 className="text-3xl font-bold tracking-tight text-[#101828] mb-3">
                Page Not Located
              </h1>
              <p className="text-sm text-[#667085] leading-relaxed mb-8">
                The resource or page you requested does not exist or has been relocated within the
                corporate website.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/"
                  className="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold text-white bg-[#101828] hover:bg-[#0D66E4] rounded-full transition-colors"
                >
                  Return to Home
                </Link>
                <Link
                  to="/products"
                  className="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold text-[#101828] hover:bg-[#F6F8FB] border border-[#E4E7EC] rounded-full transition-colors"
                >
                  View Products
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
